export const BOOKING_URL = 'https://schedule.jarvisanalytics.com/frame?eoid=19423&elid=19000000000594';
